import { useMasterDataDeductionTypes } from "@src/presentation/providers/MasterDataDeductionTypesDataProvider";
import { MasterDataListFooter } from "./MasterDataListFooter";

export const MasterDataDeductionTypesFooter = () => {
  const { total, page, limit, loading, setPage } = useMasterDataDeductionTypes();

  return (
    <MasterDataListFooter
      total={total}
      page={page}
      limit={limit}
      loading={loading}
      onPageChange={setPage}
      ariaLabel="Deduction Types Pagination"
    />
  );
};
